module.exports = __webpack_public_path__ + "media/partners/media-kit-c362f9c0.svg";